import { filter } from 'lodash';

const _ = { filter };

export const filterMembers = (membersArr, memberId) => {
    return _.filter(membersArr, member => member.memberId !== memberId);
};

export const getDisplayName = member => member.displayName || `${member.firstName} ${member.lastName}`;

export const isPlayerRated = (profile) => {
    return profile.ratingStatus === 'Rated' ||
        profile.ratingStatusSingles === 'Rated' ||
        profile.ratingStatusDoubles === 'Rated' ||
        profile.myUtrStatusSingles === 'Rated' ||
        profile.myUtrStatusDoubles === 'Rated';
};

export const playerLevelDescriptions = {
    WTA: 'WTA',
    ATP: 'ATP',
};

export const playerGenderDescriptions = {
    MALE: 'Male',
    FEMALE: 'Female',
};
